
import { useState } from 'react';

export default function Contact() {
  const [formData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  return (
    <section id="contact" className="relative py-24 bg-gradient-to-b from-[#0a0a0a] to-black overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(45deg, #D4AF37 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full mb-6">
            <i className="ri-mail-send-line text-[#D4AF37]"></i>
            <span className="text-[#D4AF37] text-sm font-medium tracking-wider">GET IN TOUCH</span>
          </div>
          <h3 className="font-['Orbitron'] text-4xl sm:text-5xl font-bold text-white mb-4">
            Ready to <span className="text-[#D4AF37]">Clear Out?</span>
          </h3>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Get your free quote sent directly to your email and phone. We&apos;ll respond within 24 hours.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            {/* Quick Contact */}
            <div className="bg-gradient-to-br from-[#D4AF37]/10 to-transparent rounded-2xl border border-[#D4AF37]/30 p-8">
              <h4 className="font-['Orbitron'] text-2xl font-bold text-white mb-6">Quick Contact</h4>
              
              <div className="space-y-6">
                <a href="tel:+19514911655" className="flex items-center gap-4 group cursor-pointer">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-xl group-hover:scale-105 transition-transform">
                    <i className="ri-phone-line text-2xl text-black"></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Primary Line</p>
                    <p className="text-white text-xl font-semibold group-hover:text-[#D4AF37] transition-colors">
                      (951) 491-1655
                    </p>
                  </div>
                </a>

                <a href="tel:+19514913198" className="flex items-center gap-4 group cursor-pointer">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#3D3225] rounded-xl group-hover:scale-105 transition-transform">
                    <i className="ri-phone-line text-2xl text-[#C4A574]"></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Secondary Line</p>
                    <p className="text-white text-xl font-semibold group-hover:text-[#D4AF37] transition-colors">
                      (951) 491-3198
                    </p>
                  </div>
                </a>

                <a href="mailto:ahjunkremoval2026@gmail.com" className="flex items-center gap-4 group cursor-pointer">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-xl group-hover:scale-105 transition-transform">
                    <i className="ri-mail-line text-2xl text-black"></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Primary Email</p>
                    <p className="text-white text-lg font-semibold group-hover:text-[#D4AF37] transition-colors">
                      ahjunkremoval2026@gmail.com
                    </p>
                  </div>
                </a>

                <a href="mailto:junkremoval.ah@gmail.com" className="flex items-center gap-4 group cursor-pointer">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#3D3225] rounded-xl group-hover:scale-105 transition-transform">
                    <i className="ri-mail-line text-2xl text-[#C4A574]"></i>
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Secondary Email</p>
                    <p className="text-white text-lg font-semibold group-hover:text-[#D4AF37] transition-colors">
                      junkremoval.ah@gmail.com
                    </p>
                  </div>
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-gray-800 p-8">
              <h4 className="font-['Orbitron'] text-xl font-bold text-white mb-6">Follow Us</h4>
              
              <div className="flex gap-4">
                <a
                  href="https://www.facebook.com/marketplace/item/1188411236700848/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 flex items-center justify-center gap-3 py-4 bg-black/50 border border-gray-700 rounded-xl hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer"
                >
                  <i className="ri-facebook-fill text-2xl text-[#D4AF37]"></i>
                  <span className="text-white font-medium">Facebook</span>
                </a>
                <a
                  href="https://instagram.com/a.hjunkremoval"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 flex items-center justify-center gap-3 py-4 bg-black/50 border border-gray-700 rounded-xl hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer"
                >
                  <i className="ri-instagram-line text-2xl text-[#D4AF37]"></i>
                  <span className="text-white font-medium">Instagram</span>
                </a>
              </div>
            </div>

            {/* Service Area */}
            <div className="bg-[#3D3225]/30 rounded-2xl border border-[#C4A574]/30 p-8">
              <div className="flex items-center gap-3 mb-4">
                <i className="ri-map-pin-line text-2xl text-[#C4A574]"></i>
                <h4 className="font-['Orbitron'] text-xl font-bold text-white">A&H Junk Removal</h4>
              </div>
              <p className="text-gray-300 mb-3">
                Proudly serving Riverside County and surrounding cities including:
              </p>
              <ul className="text-gray-300 space-y-1 text-sm">
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-2-fill text-[#C4A574] text-xs"></i>
                  Riverside, Corona, Moreno Valley
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-2-fill text-[#C4A574] text-xs"></i>
                  Temecula, Murrieta, Menifee
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-2-fill text-[#C4A574] text-xs"></i>
                  Perris, Lake Elsinore, Hemet
                </li>
              </ul>
            </div>
          </div>

          {/* Submit Quote with Photos Button - BIG BOX */}
          <div className="bg-gradient-to-br from-[#D4AF37]/30 via-[#3D3225]/60 to-black rounded-2xl border-2 border-[#D4AF37] p-10 flex flex-col items-center justify-center text-center shadow-2xl shadow-[#D4AF37]/20">
            <style>{`
              @keyframes goldFlash {
                0%, 100% { color: #D4AF37; text-shadow: 0 0 8px #D4AF37, 0 0 20px #D4AF37aa; }
                50% { color: #fff8dc; text-shadow: 0 0 24px #FFD700, 0 0 60px #FFD700; }
              }
              @keyframes borderPulse {
                0%, 100% { box-shadow: 0 0 10px #D4AF37aa, 0 0 30px #D4AF3755; }
                50% { box-shadow: 0 0 30px #FFD700cc, 0 0 60px #FFD70066; }
              }
              .flash-gold-text {
                animation: goldFlash 1s ease-in-out infinite;
              }
              .pulse-border {
                animation: borderPulse 1.5s ease-in-out infinite;
              }
            `}</style>

            <div className="w-20 h-20 flex items-center justify-center bg-[#D4AF37] rounded-full mb-6 shadow-lg shadow-[#D4AF37]/40">
              <i className="ri-file-list-3-line text-4xl text-black"></i>
            </div>

            <h4 className="font-['Orbitron'] text-3xl font-black text-white mb-3 leading-tight">
              CLICK TO SEND A<br />
              <span className="flash-gold-text">REQUEST FORM</span>
            </h4>

            <p className="text-gray-300 text-base mb-8 max-w-xs">
              Upload photos of your junk for a faster, more accurate quote — straight through our Google Form.
            </p>

            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdkZ8TSi2TMfxdQmPy-bKHSpMQqj55rgjUnuK_lcoM8m9ejWw/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="pulse-border flex items-center justify-center gap-3 w-full py-5 bg-black border-2 border-[#D4AF37] rounded-xl hover:bg-[#D4AF37]/10 transition-all cursor-pointer whitespace-nowrap font-['Orbitron'] font-bold text-xl tracking-widest"
            >
              <i className="ri-camera-fill text-2xl flash-gold-text"></i>
              <span className="flash-gold-text">SUBMIT QUOTE</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
